import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router'
import '@enterprise-ui/canvas-ui-css'
import '@enterprise-ui/canvas-ui-css-autocomplete'
import '@enterprise-ui/canvas-ui-css-datepicker'
import { HelveticaForTarget } from '@enterprise-ui/component-font'
import { AuthProvider, useAuth } from '@praxis/component-auth'
import { AnalyticsProvider } from '@praxis/analytics/client'
import { getLocation } from '@praxis/runtime-utils/getLocation'
import { UncaughtError } from './globalComponents/UncaughtError'
import { VendorProvider } from './globalState/Vendor/index'
import { isTargetOrPOLDomain } from './services/auth'
import './globalStyles/customStyles.scss'
import { Main } from './views/Main'
import apiConfig from './globalConfig/apiConfig'
import { SavedViewProvider } from './globalState/SavedViews'
import { routes } from './globalConfig/routes'
import { itemCommonUtilis } from 'item-component'
import { CostSearchProvider } from './globalState/CostSearch'
import { CostChangeInsightsGlobalProvider } from './globalState/CostChangeInsights'
import { NotificationsProvider } from './globalState/ManageNotifications'
import { ROUTER_BASENAME } from './globalConfig/constants'
import { OpenTelemetryManager } from '@measurement/opentelemetry-web'

const OTELconfig = {
  apiKey: apiConfig.OTELApiKey,
  serviceName: 'hesperidesexternal',
}
// I created an override in package.json: "@protobufjs/inquire": "1.1.0", as a workaround to get OTEL working with Praxis. After measurement puts out an updated version to fix the Praxis issue, we can remove the overwride and upgrade.

OpenTelemetryManager.initialize(OTELconfig)

const App = () => {
  const location = getLocation()
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route element={<Layout />} errorElement={<UncaughtError />}>
        {routes}
      </Route>,
    ),
    { basename: ROUTER_BASENAME },
  )

  function Layout() {
    return (
      <>
        <HelveticaForTarget variants={['n4', 'n5', 'n7']} />
        <AuthProvider
          {...apiConfig.auth}
          loginRedirect={`${location.origin}${itemCommonUtilis.findAppPath()}`}
          logoutRedirect={`${location.origin}${itemCommonUtilis.findAppPath()}`}
          shouldSendHeaders={isTargetOrPOLDomain}
        >
          <AppWithAuth />
        </AuthProvider>
      </>
    )
  }

  function AppWithAuth() {
    const accessToken = useAuth()?.session?.accessToken

    const eventManagerConfiguration = {
      ...apiConfig.analytics,
      apiKey: apiConfig.apiKey,
      fetch: (req) => {
        req.headers.set('Authorization', `Bearer ${accessToken}`)
        return fetch(req)
      },
    }

    return (
      <AnalyticsProvider config={eventManagerConfiguration}>
        <VendorProvider>
          <CostSearchProvider>
            <CostChangeInsightsGlobalProvider>
              <SavedViewProvider>
                <NotificationsProvider>
                  <Main />
                </NotificationsProvider>
              </SavedViewProvider>
            </CostChangeInsightsGlobalProvider>
          </CostSearchProvider>
        </VendorProvider>
      </AnalyticsProvider>
    )
  }

  return <RouterProvider router={router} />
}

export default App
